import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getConfig = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramcfg/getconfig' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const loginTestAccount = (params, urlParams) => {
  return axios.request({
    url: '/wxmp/wechatminiprogramcfg/logintestaccount' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

